/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Actions from '../../../actions'
import { Spin } from 'antd'

// this page have 2 options:
// 1. render the nh page in webview from app (react native) - not authenticated and url is nh-page-public
// 2. render the nh page from web - authenticated and url is nh-page
const NHPage = () => {
  const dispatch = useDispatch()

  const userDetails = useSelector(state => state.profile.userDetails)
  const ssoParams = useSelector(state => state.nhMember.ssoParams)
  const currentRoute = useSelector(state => state.router.location)

  // nh page is render in webview from app (react native)
  // in this case the url will be nh-page-public and it won't be authenticated
  // we need to send the sso params in post message from mobile to web
  const isExternalNHPage = currentRoute?.pathname?.includes('nh-page-public')

  useEffect(() => {
    // no need to get the sso params if it's external page
    // on external page we get the params from post message
    if (isExternalNHPage) {
      const decodedQuery = Object.keys(currentRoute?.query).reduce(
        (acc, curr) => {
          return {
            ...acc,
            [curr]: decodeURIComponent(currentRoute?.query[curr]),
          }
        },
        {}
      )
      dispatch(Actions.createAction(Actions.NH_SSO_INFO_RECEIVED, decodedQuery))
    } else {
      getSSOParams()
    }
  }, [])

  useEffect(() => {
    // post sso just if you have the token
    if (ssoParams?.token) {
      postSSO()
    }
  }, [ssoParams])

  // get the sso params from the server
  // will be called only if it's not external page
  const getSSOParams = () => {
    dispatch(
      Actions.createAction(Actions.NH_SSO_INFO_REQUESTED, {
        patientId: userDetails?.id,
      })
    )
  }

  // post sso using js
  const postSSO = async () => {
    const form = document.createElement('form')
    // in its not external page, do not navigate on SOW web,
    // open new tab
    if (!isExternalNHPage) {
      form.target = '_blank'
    }
    form.method = 'POST'
    form.action =
      ssoParams?.sso_url ||
      'https://uatsso1030.rxadvance.com/rxaidp/IdpInitiator/569fa53f-6f1e-4613-bb60-df4ac2407b89'

    const params = {
      SiteToken: ssoParams?.token,
      SSOAttributes: ssoParams?.xml_base64,
      RelayState: ssoParams?.replayState || 'HOME',
    }

    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const hiddenField = document.createElement('input')
        hiddenField.type = 'hidden'
        hiddenField.name = key
        hiddenField.value = params[key]

        form.appendChild(hiddenField)
      }
    }

    document.body.appendChild(form)
    form.submit()

    // navigate back after opening new tab if its not external page
    if (!isExternalNHPage) {
      // the timout is for other browsers that don't support the pop-up
      setTimeout(function () {
        dispatch(Actions.createAction(Actions.NH_SSO_INFO_CLEAR))
        dispatch(Actions.createAction(Actions.NAVIGATED_BACK))
      }, 1000)
    }
  }

  return <Spin size="large" />
}

export default NHPage
